// extracted by mini-css-extract-plugin
export default {"contenedor":"styles_contenedor__iliKC","img":"styles_img__3U+a5","logo":"styles_logo__FoBre","sombra":"styles_sombra__aR4ZT"};